import { PropsWithChildren } from 'react';
import { useRootSelector } from '../../../../../store/hooks';
import { selectSitePricingBookingClosedMessage } from '../../../store/features/bookingClosed';

import OrderNotFound from '../../../pages/errors/OrderNotFound';
import BookingClosed from '../../../pages/errors/BookingClosed';
import OrderExpired from '../../../pages/errors/OrderExpired';

type StatusCode = number | undefined;

interface ErrorHandlerProps extends PropsWithChildren {
  statusCodes: StatusCode[];
}

export default function ErrorHandler(props: ErrorHandlerProps) {
  const { children, statusCodes } = props;
  const bookingClosedMessage = useRootSelector(
    selectSitePricingBookingClosedMessage,
  );

  if (statusCodes.includes(400) || statusCodes.includes(404)) {
    return <OrderNotFound />;
  }

  if (statusCodes.includes(410)) {
    return <OrderExpired />;
  }

  if (statusCodes.includes(423)) {
    return <BookingClosed errorMessage={bookingClosedMessage} />;
  }

  return <>{children}</>;
}
